import { render, staticRenderFns } from "./WeightHeight.vue?vue&type=template&id=b120d536&"
import script from "./WeightHeight.vue?vue&type=script&lang=js&"
export * from "./WeightHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports